<template>
  <div>
    <b-table
      style="border: 1px solid rgb(0, 0, 0, 0.1); border-radius: 5px; margin-top: 12px"
      :items="flugeinkaufData"
      :fields="flugeinkaufFields"
      :sort-by="'startdatumHotelleistung'"
      :sort-desc="false"
      responsive
      head-variant="light"
    >
      <template v-slot:cell(reisetermin.reiseterminkuerzel)="data">
        <div style="width: 150px">
          {{ data.value }}
        </div>
      </template>
      <template v-slot:cell(status)="row">
        <span
          class="kachel-badge"
          :class="
            row.item.status === 'Verfuegbar'
              ? 'green'
              : row.item.status === 'NichtVerfuegbar'
              ? 'red'
              : 'yellow'
          "
        >
          {{ row.item.status === 'Verfuegbar' ? 'J' : row.item.status === 'NichtVerfuegbar' ? 'N' : 'RQ' }}
        </span>
      </template>
      <template v-slot:cell(pax)="row">
        <PaxWidget
          :paxObject="row.item.reisetermin.pax"
          :minPax="row.item.reisetermin.metadata.minPax"
          :maxPax="row.item.reisetermin.metadata.maxPax"
          :kalkPax="row.item.reisetermin.metadata.kalkPax"
          :forecastPax="row.item.reisetermin.metadata.forecastPax"
          :durchfuehrbareMinPax="row.item.reisetermin.metadata.durchfuehrbareMinPax"
        ></PaxWidget>
      </template>
      <template v-slot:cell(ziellandAbUndZielflughafen)="row">
        {{ row.item.reisetermin.metadata.ziellandZielflughaefen.map(fh => fh.flughafenIataCode).join(', ') }}
        /
        {{ row.item.reisetermin.metadata.ziellandAbflughaefen.map(fh => fh.flughafenIataCode).join(', ') }}
      </template>
      <template v-slot:cell(thMax)="row">
        {{ formatThMax(row.item.reisetermin) }}
      </template>
      <template v-slot:cell(gesamtpreisGrp)="row">
        {{ formatGesamtpreisGrp(row.item.reisetermin) }}
      </template>
      <template v-slot:cell(statusGrp)="row">
        {{ translateStatusGruppeOptions(row.item.reisetermin.flugeinkauf?.statusgruppe) }}
      </template>
      <template v-slot:cell(einkaufsart)="row">
        {{ translateEinkaufsartOptions(row.item.reisetermin.flugeinkauf?.einkaufsart) }}
      </template>
      <template v-slot:cell(optionsfrist)="row">
        {{ formatOptionsfrist(row.item.reisetermin) }}
      </template>
      <template v-slot:cell(aufgaben)="row">
        <b-badge :id="'tooltip-target-flugeinkauf' + row.item.id">
          {{ row.item.aufgaben?.length }}
        </b-badge>
        <b-tooltip
          :target="'tooltip-target-flugeinkauf' + row.item.id"
          triggers="hover"
          custom-class="custom-tooltip"
          v-if="row.item.aufgaben?.length > 1"
        >
          <AufgabenWidget
            :openAufgabenId="openAufgabenId"
            class="mt-3"
            :ansicht="'aufgabe-details'"
            :aufgaben="row.item.aufgaben || []"
          ></AufgabenWidget>
        </b-tooltip>
      </template>
    </b-table>
  </div>
</template>
<script>
import PaxWidget from '@/components/produkte/reisetermine/pax-widget.vue';
import AufgabenWidget from '@/components/produkte/reisetermine/aufgaben-widget.vue';
import {
  formatDateWithoutHours,
  formatAndCalculateReleasedatum,
  translateEinkaufsartOptions,
  translateStatusGruppeOptions,
} from '@/core/common/helpers/utils';
export default {
  components: { PaxWidget, AufgabenWidget },
  props: {
    flugeinkaufData: { type: Array, required: true },
    openAufgabenId: { type: Number, default: null },
  },
  data() {
    return {
      flugeinkaufFields: [
        {
          tdClass: 'align-middle',
          key: 'reisetermin.reiseterminkuerzel',
          label: 'Reiseterminkürzel',
        },
        { tdClass: 'align-middle', key: 'deutscherAbflughafenIataCode', label: 'Abflughafen' },
        {
          tdClass: 'align-middle',
          key: 'startdatumHotelleistung',
          label: 'Startdatum',
          formatter: value => {
            return this.formatDateWithoutHours(value);
          },
        },
        { tdClass: 'align-middle', key: 'status', label: 'Status' },
        {
          tdClass: 'align-middle',
          key: 'aufpreis',
          label: 'Aufpreis',
          formatter: value => (!isNaN(parseInt(value)) ? value + '€' : '-'),
        },
        {
          tdClass: 'align-middle',
          key: 'flugstammHinflug',
          label: 'Flugstamm Hin',
          thStyle: { whiteSpace: 'nowrap' },
        },
        { tdClass: 'align-middle', key: 'pax', label: 'PAX' },
        {
          tdClass: 'align-middle',
          key: 'ziellandAbUndZielflughafen',
          label: 'Zielland Ziel-/Abfh.',
          thStyle: { whiteSpace: 'nowrap' },
        },
        {
          tdClass: 'align-middle',
          key: 'reisetermin.thGesamt',
          label: 'TH Wert',
          thStyle: { whiteSpace: 'nowrap' },
          formatter: value => (isNaN(parseInt(value)) ? '-' : value + '€'),
        },
        {
          tdClass: 'align-middle',
          key: 'thMax',
          label: 'TH Max',
          thStyle: { whiteSpace: 'nowrap' },
        },
        {
          tdClass: 'align-middle',
          key: 'gesamtpreisGrp',
          label: 'Gesamtpreis GRP',
          thStyle: { whiteSpace: 'nowrap' },
        },
        { tdClass: 'align-middle', key: 'statusGrp', label: 'Status GRP' },
        { tdClass: 'align-middle', key: 'einkaufsart', label: 'Einkaufsart' },
        {
          tdClass: 'align-middle',
          key: 'optionsfrist',
          label: 'Optionsfrist',
          thStyle: { whiteSpace: 'nowrap' },
        },
        { tdClass: 'align-middle', key: 'aufgaben', label: 'Aufgaben' },
      ],
    };
  },
  methods: {
    formatDateWithoutHours,

    // Bildet die Summe aus TH Max Langstrecke und TH Max Inlandsflug
    formatThMax(reisetermin) {
      const saisonpreis = reisetermin?.gueltigerSaisonpreis;
      if (!saisonpreis) return '-';
      const summe = (saisonpreis.thMaxLangstrecke ?? 0) + (saisonpreis.thMaxInlandsflug ?? 0);
      return summe ? summe + '€' : '-';
    },

    // Zieht den Gesamtpreis aus dem FRA-Gruppeneinkauf
    formatGesamtpreisGrp(reisetermin) {
      const fraGruppeneinkauf = reisetermin?.flugeinkauf?.gruppeneinkaeufe?.find(
        gruppe => gruppe.flughafenIataCode === 'FRA'
      );
      return fraGruppeneinkauf?.gesamtpreisGruppeneinkauf != null
        ? fraGruppeneinkauf.gesamtpreisGruppeneinkauf + '€'
        : '-';
    },

    formatOptionsfrist(reisetermin) {
      const optionsfrist = reisetermin?.flugeinkauf?.optionsfrist;
      if (optionsfrist == null) return '-';
      return formatAndCalculateReleasedatum(reisetermin.startdatum, optionsfrist);
    },

    translateEinkaufsartOptions,

    translateStatusGruppeOptions,
  },
};
</script>
